import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class SlideOverComponent extends Component {
  slideoverOpenContainerClass = `slideover-container-open`;
  slideoverOpenContentClass = 'translate-x-0';

  slideoverCloseContainerClass = 'hidden';
  slideoverCloseContentClass = 'translate-x-full';
  element = null;

  get isOpen() {
    return this.args.isOpen;
  }

  @tracked bounds = this.args.bounds ?? '.slideover-content';

  @action
  closeSlideOver() {
    this.args?.close?.(false);
  }

  stopPropagation(e) {
    e.stopPropagation();
  }

  @action
  addEventListeners(element) {
    element.addEventListener('click', this.closeSlideOver);

    const content = element.querySelector(this.bounds);
    content?.addEventListener('click', this.stopPropagation);

    this.element = element;
  }

  @action
  onSlideoverUpdate(element) {
    const content = element.querySelector('.slideover-content');
    if (this.isOpen) {
      content.classList.remove(this.slideoverCloseContentClass);
      content.classList.add(this.slideoverOpenContentClass);
      element.classList.remove(this.slideoverCloseContainerClass);
      element.classList.add(this.slideoverOpenContainerClass);
    } else {
      content.classList.remove(this.slideoverOpenContentClass);
      content.classList.add(this.slideoverCloseContentClass);
      let timeout = 500;
      setTimeout(() => {
        element.classList.remove(this.slideoverOpenContainerClass);
        element.classList.add(this.slideoverCloseContainerClass);
        const duration = Array.from(content.classList).filter((item) =>
          item.includes('duration-'),
        )?.[0];
        timeout = duration ? +duration.split('-')[1] + 50 : 500;
      }, timeout);
    }
  }

  willDestroy() {
    super.willDestroy(...arguments);
    this.element?.removeEventListemer?.('click', this.closeSlideOver);
    const content = this.element?.querySelector?.(this.bounds);
    content?.removeEventListemer?.('click', this.stopPropagation);
  }
}
